import AppConstants from '../../../../constants/AppConstants';
import DashboardActions from '../../../../actions/DashboardActions';
import moment from 'moment';
import config from '../../../../config';
import store from '../../../../stores/redux';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';

const reportUtils = ReportComponent.utils;

export const actions = {
    getLastData() {
        const state = store.getState();
        const user = state.user;
        const savedMetrics = state?.serverStorage?.store?.report?.metrics;

        let columns = reportUtils.getKeysMetric(
            typeof savedMetrics === 'string' && savedMetrics.length
                ? savedMetrics
                : reportUtils.getDefStrMetric()
        );

        let params = {
            publishers: [],
            group_by: 'Day',
            from_day: moment.utc().startOf('day').subtract(6, 'days').format(config.reportDateFormat),
            to_day: moment.utc().endOf('day').add(1, 'days').format(config.reportDateFormat),
            timezone: 'UTC', // dashboard data are shown in UTC (see the note under "Last 7 days")
            currency: user?.publisher?.account?.balance?.currency || 'USD',
            columns: columns,
            totals: '1',
            isHomePage: 1
        };

        return DashboardActions.getLastData(params).catch(err => {
            console.warn('DashboardTable getLastData error:', err);
            throw err;
        });
    },

    clear() {
        return {
            type: AppConstants.DASHBOARD_CLEAR
        };
    }
};
